import { useDraggable } from "@dnd-kit/core";
import { useNavigate } from "react-router-dom";
import { CalendarClock, MoreHorizontal } from "lucide-react";
import { STAGES } from "@/lib/constants";
import { fmtDate } from "@/lib/format";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { ChannelIcon } from "@/components/crm/ChannelIcon";

export const CardBody = ({ lead }) => (
  <>
    <p className="pr-7 text-sm font-semibold leading-snug text-[#0B2545]">{lead.full_name}</p>
    <p className="mt-1 text-xs text-slate-500">{lead.service_name || "Sin servicio"}</p>
    <div className="mt-3 flex items-center justify-between gap-2 text-xs text-slate-500">
      <span className="inline-flex items-center gap-1"><ChannelIcon channel={lead.channel} className="h-3.5 w-3.5 text-[#1E6FD9]" /> {lead.channel}</span>
      <span className={`truncate ${lead.assigned_seller_name ? "" : "font-medium text-rose-600"}`}>{lead.assigned_seller_name || "Sin asignar"}</span>
    </div>
    {lead.next_action && (
      <p className="mt-2.5 flex items-start gap-1.5 rounded-lg bg-[#F5F7FA] px-2 py-1.5 text-[11px] text-slate-600">
        <CalendarClock className="mt-px h-3 w-3 shrink-0 text-[#14B8A6]" />
        <span>{lead.next_action}{lead.next_action_date && ` · ${fmtDate(lead.next_action_date)}`}</span>
      </p>
    )}
  </>
);

export const PipelineCard = ({ lead, onMove }) => {
  const navigate = useNavigate();
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({ id: lead.id, data: { lead } });
  return (
    <div ref={setNodeRef} {...listeners} {...attributes} onClick={() => navigate(`/crm/leads/${lead.id}`)}
         className={`relative cursor-grab touch-pan-x rounded-xl border border-slate-200/80 bg-white p-3.5 shadow-[0_1px_2px_rgba(11,37,69,0.05)] transition-[box-shadow,opacity] hover:shadow-md active:cursor-grabbing ${isDragging ? "opacity-30" : ""}`}
         data-testid={`pipeline-card-${lead.id}`}>
      <CardBody lead={lead} />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button onClick={(e) => e.stopPropagation()} onPointerDown={(e) => e.stopPropagation()} aria-label="Mover a…"
                  className="absolute right-2 top-2 grid h-7 w-7 place-items-center rounded-lg text-slate-400 hover:bg-slate-100 hover:text-[#0B2545]"
                  data-testid={`pipeline-card-menu-${lead.id}`}>
            <MoreHorizontal className="h-4 w-4" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
          <DropdownMenuLabel className="text-xs text-slate-500">Mover a…</DropdownMenuLabel>
          {STAGES.filter((s) => s !== lead.stage).map((s) => (
            <DropdownMenuItem key={s} onSelect={() => onMove(lead, s)} data-testid={`move-to-${s}`}>{s}</DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
